import {combineReducers} from "redux";

import Auth from "./auth/reducers";
import Layout from "./layout/reducers";
import uiReducer from './ui/uiReducer';
import messageReducer from './messages/messagesReducer';

export default combineReducers({
    Auth,
    Layout,
    uiReducer,
    messageReducer
});
